var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThermometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.634 17.898l1.805-.214a2 2 0 001.179-.572l7.221-7.221a3.965 3.965 0 000-5.608v0a3.965 3.965 0 00-5.608 0L7.01 11.504a2 2 0 00-.572 1.179l-.214 1.805a2 2 0 01-.572 1.179l-1.937 1.937a1.983 1.983 0 000 2.804v0c.774.774 2.03.774 2.804 0l1.937-1.937c.316-.319.732-.52 1.178-.573zM17.22 10.23l1.14 1.14M15.07 12.32l1.17 1.17M12.95 14.44l1.17 1.17M16.33 7.79l-6.79 6.79M4.81 16.5l2.8 2.81"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

export default SvgThermometer;


//////////////////
// WEBPACK FOOTER
// ./src/icons/thermometer.svg
// module id = 831
// module chunks = 101